import React, { useEffect, useState, useCallback } from "react";
import { endpoints } from "../config/api";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  backgroundColor: "#0b1220",
};

const logoStyle = {
  width: "120px",
  marginBottom: "20px",
};

const titleStyle = {
  color: "#ffffff",
  marginBottom: "16px",
};

const errorStyle = {
  color: "red",
  marginBottom: "12px",
};

const isTokenValid = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

const Login = ({ onLogin }) => {
  const [error, setError] = useState("");
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const authority = localStorage.getItem("authority");

    if (token && isTokenValid(token)) {
      onLogin({ access_token: token, authority });
    } else {
      localStorage.removeItem("access_token");
      localStorage.removeItem("authority");
    }
  }, [onLogin]);

  const handleGoogleLogin = useCallback(
    async (response) => {
      setError("");

      try {
        const res = await fetch(
          endpoints.authLogin,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token: response.credential }),
          }
        );

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.message || "Unauthorized");
        }

        const result = await res.json();
        const loginData = result.data;

        if (!loginData?.access_token) {
          throw new Error("Access token missing in response");
        }

        localStorage.setItem("access_token", loginData.access_token);
        localStorage.setItem("authority", loginData.authority);

        onLogin(loginData);
      } catch (err) {
        setError(typeof err?.message === "string" ? err.message : "Login failed");
      }
    },
    [onLogin]
  );

  useEffect(() => {
    const loadGoogleScript = () =>
      new Promise((resolve) => {
        if (window.google) return resolve();

        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        document.body.appendChild(script);
      });

    loadGoogleScript().then(() => {
      if (!window.google) {
        setError("Google failed to load");
        return;
      }

      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleGoogleLogin,
      });

      window.google.accounts.id.renderButton(
        document.getElementById("google-login"),
        {
          theme: "filled_blue",
          size: "large",
          width: 280,
        }
      );
    });
  }, [handleGoogleLogin]);

  return (
    <div style={containerStyle}>
      <img src="/logo.png" alt="Logo" style={logoStyle} />
      <h1 style={titleStyle}>Welcome to Muns.ai Admin Panel</h1>

      {error && <p style={errorStyle}>{error}</p>}

      <div id="google-login" />
    </div>
  );
};

export default Login;
